import type { MaintenanceJob } from '../types/index.js'

/** Délai au-delà duquel une tâche jamais prise en charge signale le contrôleur. */
export const MAINTENANCE_PICKUP_TIMEOUT_MS = 20_000

/**
 * Le contrôleur hôte scrute les demandes chaque seconde : une tâche encore
 * `QUEUED` après ce délai n'est pas lue (contrôleur arrêté, fichier illisible),
 * et l'attendre indéfiniment laisse l'écran tourner sans explication.
 */
export function maintenanceJobStalled(job: Pick<MaintenanceJob, 'state' | 'createdAt'>, now: number = Date.now()): boolean {
  if (job.state !== 'QUEUED') return false
  const created = Date.parse(job.createdAt)
  return Number.isFinite(created) && now - created > MAINTENANCE_PICKUP_TIMEOUT_MS
}
